import { Title } from "ui/Typography"
import { ChatHistory } from "pagesV2/pro/Messages/ChatHistory"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { createConversation, getConversations } from "store/conversations"
import { Card, Spin } from "antd"
import styles from "./index.module.css"
import { useTranslation } from "react-i18next"
import { LoadingOutlined } from "@ant-design/icons"
import PropTypes from "prop-types"

const MessagesTab = ({ active }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [subscription, setSubscription] = useState(null)
  const [loading, setLoading] = useState(false)
  const [selectedConversationId, setSelectedConversationId] = useState(null)
  const client = useSelector((state) => state?.clients?.client)

  useEffect(() => {
    if (active) {
      setLoading(true)
      const conversation_id = client?.conversation_id
      if (conversation_id) {
        setSelectedConversationId(conversation_id)
        dispatch(getConversations()).finally(() => {
          setLoading(false)
        })
      } else {
        dispatch(createConversation({ participant_id: client?.user_id })).then((conversation) => {
          setSelectedConversationId(conversation?.id)
          dispatch(getConversations()).finally(() => {
            setLoading(false)
          })
        })
      }
    }
  }, [dispatch, active, client])

  return (
    <Card>
      <Title level={5}>{t("client.messages")}</Title>
      {loading ? (
        <Spin size="large" indicator={<LoadingOutlined spin />} style={{ width: "100%", margin: "16px 0" }} />
      ) : (
        <ChatHistory
          moduleName={styles.clientMessageTab}
          selectedConversationId={selectedConversationId}
          subscription={subscription}
          setSubscription={setSubscription}
          guideClientId={client?.id}
          isShowHeader={false}
        />
      )}
    </Card>
  )
}

MessagesTab.propTypes = {
  active: PropTypes.bool
}

export default MessagesTab
